import type React from "react";
import { cx } from "@/utils/cx";

type InputProps = React.ComponentProps<"input"> & {
	error?: boolean;
	/** Accepted for compatibility with base Input; no-op here (shared Input has no trailing icon). */
	hideTrailingErrorIcon?: boolean;
};

function Input({
	className,
	type,
	error = false,
	hideTrailingErrorIcon: _hideTrailingErrorIcon,
	...props
}: InputProps) {
	return (
		<input
			aria-invalid={error}
			className={cx(
				"h-10 w-full min-w-0 rounded-md border border-primary bg-white px-3.5 py-1 text-gray-900 text-md shadow-xs outline-none transition-[color,box-shadow] selection:bg-brand-600 selection:text-primary_on-brand file:inline-flex file:h-7 file:border-0 file:bg-transparent file:font-medium file:text-foreground file:text-sm placeholder:text-gray-500 dark:bg-gray-950 dark:text-gray-50 dark:placeholder:text-gray-400",
				"focus-visible:border-ring focus-visible:ring-2 focus-visible:ring-brand",
				"aria-invalid:border-error_subtle aria-invalid:ring-error_subtle dark:aria-invalid:ring-error_subtle",
				"disabled:cursor-not-allowed disabled:border-disabled disabled:bg-disabled_subtle disabled:text-disabled",
				className
			)}
			data-slot="input"
			type={type}
			{...props}
		/>
	);
}

export { Input };
